// extracted by mini-css-extract-plugin
export default {"icon":"uPqNgx","text":"Vl7Kh5","button":"avNYon","textButton":"nD_ewh","iconButton":"wDDBnW","animated":"mF65Eo","verticalAlign":"wC4Oam"};